import { Row as AntRow } from "antd";

const Row = AntRow;

export default Row;
